import Image from 'next/image';
import { FC, useEffect, useState } from 'react';
import { useFormContext } from '../../../../../contexts/FormContext';
import { FormType } from '../../../../../types/FormTypes';
import { OutputTextarea } from './OutputTextarea';
import { FileTree } from '../../../savedContentPage/fileTree';
import styles from './GeneratedResponseArea.module.css';
import { OutputButtons } from './OutputButtons';
import { SocialOutputs } from './socialOutputs/SocialOutputs';
import { useOutputAreaContext } from '../../../../../contexts/OuputAreaContext';
import { EmailOutputs } from './emailOutput/EmailOutputs';
import { WebsiteOutputs } from './websiteOutputs/WebsiteOutputs';
import { PersonaSocialOutputs } from './socialOutputs/PersonaSocialOutputs';
import { PersonaEmailOutputs } from './emailOutput/PersonaEmailOutputs';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import { SubscriptionType } from '../../../../../types/Stripe.type';
import { BasicPopup50vw } from '../../../../shared/popups/BasicPopup';

export const GeneratedResponseArea: FC = () => {
  const { lastGeneratedFormat } = useFormContext();
  const {
    successMessage,
    setSuccessMessage,
    showFileTree,
    setShowFileTree,
    fileToBeSaved,
  } = useOutputAreaContext();
  const [container, setContainer] = useState(false);
  const { userData } = useAuthContext();

  useEffect(() => {
    if (userData?.stripe?.subscriptionType == SubscriptionType.FREE_TRIAL) {
      setContainer(true);
    } else {
      setContainer(false);
    }
  }, []);

  const RatingSuccessMessage = () => {
    return (
      <div
        className={styles['success-message-container']}
        style={{
          opacity: successMessage ? 1 : 0,
          zIndex: successMessage ? 10 : 0,
        }}
      >
        <div>
          <p>{successMessage}</p>
          <button onClick={() => setSuccessMessage('')}>
            <Image
              src="/icons/CloseWhite.svg"
              alt="X"
              layout="fixed"
              objectFit="contain"
              height={16}
              width={16}
            />
          </button>
        </div>
      </div>
    );
  };

  const getDisplayFormat = () => {
    switch (lastGeneratedFormat?.formType) {
      case FormType.EMAIL:
        return <EmailOutputs />;
      case FormType.PERSONAEMAIL:
        return <PersonaEmailOutputs />;
      case FormType.SOCIAL:
        return <SocialOutputs />;
      case FormType.PERSONA:
      case FormType.PERSONA_TWITTER:
      case FormType.PERSONA_INSTAGRAM:
      case FormType.PERSONA_LINKEDIN:
      case FormType.PERSONA_FACEBOOK:
      case FormType.TIKTOK:
      case FormType.META_ADS:
      case FormType.GOOGLE_ADS:
        return <PersonaSocialOutputs />;
      default:
      case FormType.BLOG:
      case FormType.PERSONABLOG:
        return <OutputTextarea />;
      case FormType.HERO_HEADER:
      case FormType.PERSONA_HERO_HEADER:
      case FormType.SUBHEADER:
      case FormType.PERSONA_SUBHEADER:
      case FormType.FEATURE_DESCRIPTION:
      case FormType.PERSONA_FEATURE_DESCRIPTION:
      case FormType.CALL_TO_ACTION:
      case FormType.PERSONA_CALL_TO_ACTION:
        return <WebsiteOutputs />;
    }
  };

  return (
    <div className={styles[container ? 'container2' : 'container']}>
      {getDisplayFormat()}
      {showFileTree && (
        <div>
          <div>
            <BasicPopup50vw id="persona-popup">
              <div className={styles['popup-container-content']}>
                <div className={styles['popup-header-container2']}>
                  <div className={styles['flex-row']}>
                    <Image
                      src="/icons/Folder2.svg"
                      alt="Close"
                      layout="fixed"
                      objectFit="contain"
                      height={18}
                      width={18}
                    />
                    <b>Create or select a folder location</b>
                  </div>
                  <button onClick={() => setShowFileTree(false)}>
                    <Image
                      src="/icons/CloseBlack.svg"
                      alt="Close"
                      layout="fixed"
                      objectFit="contain"
                      height={24}
                      width={24}
                    />
                  </button>
                </div>
                <div>
                  <FileTree contentID={fileToBeSaved} />
                </div>
              </div>
            </BasicPopup50vw>
          </div>
        </div>
      )}
      <div className={styles['buttons-container']}>
        {RatingSuccessMessage()}
        {lastGeneratedFormat?.formType &&
          lastGeneratedFormat.formType !== FormType.PERSONA_FACEBOOK &&
          lastGeneratedFormat.formType !== FormType.PERSONA_INSTAGRAM &&
          lastGeneratedFormat.formType !== FormType.PERSONA_LINKEDIN &&
          lastGeneratedFormat.formType !== FormType.PERSONA_TWITTER &&
          lastGeneratedFormat.formType !== FormType.SOCIAL && <OutputButtons />}
      </div>
    </div>
  );
};
